var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3,3.61803399 L19.763932,12 L3,20.381966 L3,3.61803399 Z","id":"bubble","fill":"none","strokeWidth":"2"}));
}

Play.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Play;

Play.default = Play;
